import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { TEquipmentState } from '../../../types/Equipment';
import { IAppState } from '../../../store/Store';
import { useEffect, useState } from 'react';
import { getEquipment } from '../../../actions/EquipmentActions';
import { setCurrentPageTitle } from '../../../actions/ContentActions';
import Equipment from '../../../components/equipment/Equipment';
import { useTranslation } from 'react-i18next';

const EquipmentPage: React.FC<
  RouteComponentProps<{
    id?: string;
  }>
> = ({
  match: {
    params: { id },
  },
}): JSX.Element => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const equipmentState: TEquipmentState = useSelector<
    IAppState,
    TEquipmentState
  >((state) => state.equipmentState);

  useEffect(() => {
    dispatch(getEquipment(parseInt(id as string)));
  }, [dispatch, id]);

  useEffect(() => {
    dispatch(setCurrentPageTitle(t('page.title.equipment')));
  }, [t, dispatch]);

  const [expandedInstructions, setExpandedInstructions] = useState(
    !!localStorage.getItem('expandedEqInstructions')
  );

  const [expandedDocumentation, setExpandedDocumentation] = useState(
    !!localStorage.getItem('expandedEqDocumentation')
  );

  const updateLocalStorage = (title: string, isExpanded: boolean) => {
    if (isExpanded) {
      localStorage.setItem(title, String(isExpanded));
    } else {
      localStorage.removeItem(title);
    }
  };

  const handleChange =
    (panel: string) =>
    (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      switch (panel) {
        case 'expandedEqInstructions':
          setExpandedInstructions(isExpanded);
          updateLocalStorage('expandedEqInstructions', isExpanded);
          break;
        case 'expandedEqDocumentation':
          setExpandedDocumentation(isExpanded);
          updateLocalStorage('expandedEqDocumentation', isExpanded);
          break;
      }
    };

  return (
    <>
      {equipmentState.activeEquipment && (
        <Equipment
          equipmentState={equipmentState}
          expandedInstructions={expandedInstructions}
          expandedDocumentation={expandedDocumentation}
          handleChange={handleChange}
        />
      )}
    </>
  );
};

export default withRouter(EquipmentPage);
